import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DashboardWidget } from '@h20-shared/dashboards';
import { getDateTimeFormatter } from '@h20-shared/utils/time-utils';

/** Shows what the bound query's rows cover and when they were calculated */
@Component({
    selector: 'pulse-dashboard-provenance',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslateModule],
    templateUrl: './dashboard-provenance.widget.html',
    styleUrl: './dashboard-provenance.widget.scss',
})
export class DashboardProvenanceWidget extends DashboardWidget {
    private readonly translate = inject(TranslateService);
    private readonly langChange = toSignal(this.translate.onLangChange);

    protected readonly provenanceText = computed<string | undefined>(() => {
        this.langChange();
        const meta = this.meta();
        if (meta === undefined) {
            return undefined;
        }

        const { registryName, sites } = meta.scope;
        let scope = registryName;
        if (sites !== 'all') {
            scope = `${registryName} (${sites.join(', ')})`;
        }
        if (!meta.calculatedAt) {
            return scope;
        }

        const refreshed = getDateTimeFormatter(this.translate.currentLang).format(
            new Date(meta.calculatedAt)
        );
        return this.translate.instant('Dashboard.Provenance.Line', { scope, refreshed });
    });
}
